import script from "./PCPartAddArticlePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartAddArticlePopup.vue?vue&type=script&setup=true&lang=js"

import "./PCPartAddArticlePopup.vue?vue&type=style&index=0&id=e2789010&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2789010"]])

export default __exports__